import { useNavigate } from "react-router-dom";
import Icon from "../components/Icon";
import ChangePasswordForm from "../components/ChangePasswordForm";
import { useAuth } from "../contexts/AuthContext";

const homeFor = (role) =>
  role === "super_admin" ? "/super"
  : role === "admin" ? "/admin"
  : role === "customer" ? "/portal"
  : "/me";

// Forced password change for first login on a temporary password. Reached
// only via the Authenticated guard's redirect when must_change_password is
// set; it has no nav chrome so the user can't slip past it.
export default function ChangePasswordPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="center-screen" style={{ padding: 16 }}>
      <div className="login-card" style={{ maxWidth: 420, width: "100%" }}>
        <div className="login-otp-header">
          <div className="login-otp-icon"><Icon name="lock" size={20} /></div>
          <h2>Set your own password</h2>
          <p>You signed in with a temporary password. Enter it once more and choose a new one to continue.</p>
        </div>
        <ChangePasswordForm
          submitLabel="Save & continue"
          onDone={(fresh) => navigate(homeFor(fresh?.role ?? user?.role), { replace: true })}
        />
      </div>
    </div>
  );
}
